export const canRetryHistoricalAnalysisPayment = status =>
  status === 'estimate_ready' || status === 'payment_failed';
